import React, { useState } from 'react';
import { defineMessages, useIntl } from 'react-intl-next';

import { CategorySelector, type Category } from '@confluence/category-selector';

const messages = defineMessages({
	snippetsCategoryAll: {
		id: 'snippets.panel.categories.all',
		defaultMessage: 'All',
		description:
			'Block Template side panel category name for filtering the list of templates to All templates',
	},
	snippetsCategoryMyTemplates: {
		id: 'snippets.panel.categories.myTemplates',
		defaultMessage: 'My Templates',
		description:
			'Block Template side panel category name for filtering the list of templates to templates created by the current user',
	},
	snippetsCategoryFavorites: {
		id: 'snippets.panel.categories.favorites',
		defaultMessage: 'Favorites',
		description:
			'Block Template side panel category name for filtering the list of templates to favorited templates',
	},
});

export enum SnippetCategoryId {
	ALL = 'snippets.all',
	MY_TEMPLATES = 'snippets.my-templates',
	FAVORITES = 'snippets.favorites',
}

export const SnippetCategorySelector = ({
	initialCategoryId,
	onSelectionChange,
}: {
	initialCategoryId: SnippetCategoryId;
	onSelectionChange: (category: Category) => void;
}) => {
	const intl = useIntl();

	const categoryAll: Category = {
		id: SnippetCategoryId.ALL,
		name: intl.formatMessage(messages.snippetsCategoryAll),
	};
	const categoryMyTemplates: Category = {
		id: SnippetCategoryId.MY_TEMPLATES,
		name: intl.formatMessage(messages.snippetsCategoryMyTemplates),
	};
	const categoryFavorites: Category = {
		id: SnippetCategoryId.FAVORITES,
		name: intl.formatMessage(messages.snippetsCategoryFavorites),
	};

	const categories: Category[] = [categoryAll, categoryMyTemplates, categoryFavorites];

	const [selectedCategoryId, setSelectedCategoryId] = useState(initialCategoryId);

	const onCategorySelectionChange = (category: Category) => {
		setSelectedCategoryId(category.id as SnippetCategoryId);
		onSelectionChange(category);
	};

	return (
		<CategorySelector
			categories={categories}
			selectedCategoryIds={[selectedCategoryId]}
			onCategorySelected={onCategorySelectionChange}
		/>
	);
};
